export default function field(name: string) {
  return (target: any, key: string) => {
    if (target.fields === undefined) {
      target.fields = {};
    }
    target.fields[key] = name;
  };
}
